import { z } from 'zod'
import { oc } from '@orpc/contract'
import {
  actorOverrideSchema,
  assistantConversationOutputSchema,
  threadPathSchema,
} from './assistant-conversation.contract'

export const assistantGet = oc
  .route({ method: 'GET', path: '/v2/assistant/conversations/thread' })
  .input(
    z.object({
      threadPath: threadPathSchema,
      sinceId: z.string().optional(),
      actor: actorOverrideSchema,
    }),
  )
  .output(assistantConversationOutputSchema)
